import { fetchData, postRequest, putRequest, deleteRequest } from './index';

function getMasterData(data) {
  return fetchData('/masterData', data);
}

function createMasterData(data) {
  return postRequest('/masterData', data);
}

function updateMasterData(id, data) {
  return putRequest(`/masterData/${id}`, data);
}

function deleteMasterData(data) {
  return deleteRequest('/masterData', data);
}

function getUsers() {
  return fetchData('/users');
}

function CreateUser() {
  return postRequest('/users');
}

function updateUser(data) {
  return putRequest(`/users`, data);
}

function sendSignUpMail(data) {
  return postRequest(`/users/signUpMail`, data);
}

function confirmUser(data) {
  return putRequest(`/common`, data);
}

// Lists the departing owner's home items for the move-workflow stay/go checklist
// (card 166). Identity is carried by the signed token, so the body is { token }.
function getMoveItems(data) {
  return postRequest(`/common/moveItems`, data);
}

// Completes the "I moved" transfer. `data` is { token, dispositions } where
// dispositions is [{ itemId, remainsWithResidence }].
function getToNewUser(data) {
  return putRequest(`/common/getToNewUser`, data);
}

function deleteUser(data) {
  return deleteRequest('/users', data);
}

// Deletes the signed-in homeowner's own account (card 124). The home and all of
// its items stay attached to the address for a future account there.
function deleteHomeownerAccount() {
  return deleteRequest('/homeowner');
}

// Co-homeowner (resident) invites (card 123).
function inviteResident(data) {
  return postRequest('/resident', data);
}

function getResidents() {
  return fetchData('/resident');
}

function deleteResident(id) {
  return deleteRequest(`/resident/${id}`);
}

// --- Moving workflow (card 108) --------------------------------------------
// The departing homeowner's items (services) grouped by category, plus their
// address, for the move table.
function getMoveWorkflowItems() {
  return fetchData('/move/items');
}

// Starts the move — locks the Residence address until completion.
function startMove() {
  return postRequest('/move/start');
}

// Completes the move. `data` is { dispositions: [{ serviceId, remainWithResidence }] }.
function completeMove(data) {
  return postRequest('/move/complete', data);
}

// Backs out of a move before completing it (unlocks the Residence address).
function cancelMove() {
  return postRequest('/move/cancel');
}

// New homeowner finalizes the import table. `data` is { addressId, importIds }.
function importResidenceItems(data) {
  return postRequest('/move/import', data);
}

function getAllUsers() {
  return fetchData('/users/getAllUser');
}

function sendMail(data) {
  return postRequest('/users/sendMail', data);
}
// Service
function getService(data) {
  return fetchData('/service', data);
}

function createService(data) {
  return postRequest('/service', data);
}

function updateService(id, data) {
  return putRequest(`/service/${id}`, data);
}

function deleteService(data) {
  return deleteRequest('/service', data);
}

function softDeleteService(id, data) {
  return putRequest(`/service/delete/${id}`, data);
}

function fileUploadService(id, data) {
  return putRequest(`/service/fileUpload/${id}`, data);
}

function fileDeleteService(id, data) {
  return putRequest(`/service/fileDelete/${id}`, data);
}

function getRecentEdited(data) {
  return fetchData('/service/recentEdited', data);
}
// Service

// Service records ("Service performed" log — Homeowner card 84)
function getServiceRecordItems() {
  return fetchData('/serviceRecord/items');
}

function getServiceRecords(data) {
  return fetchData('/serviceRecord', data);
}

function createServiceRecord(data) {
  return postRequest('/serviceRecord', data);
}

function updateServiceRecord(id, data) {
  return putRequest(`/serviceRecord/${id}`, data);
}

function softDeleteServiceRecord(id, data) {
  return putRequest(`/serviceRecord/delete/${id}`, data);
}

function fileUploadServiceRecord(id, data) {
  return putRequest(`/serviceRecord/fileUpload/${id}`, data);
}

function fileDeleteServiceRecord(id, data) {
  return putRequest(`/serviceRecord/fileDelete/${id}`, data);
}
// End Service records

// Master Residence
function getHomeHack(data) {
  return fetchData('/homeHack', data);
}
function getHomeHackAll(data) {
  return fetchData('/homeHack/getHomeHackAll', data);
}
function createHomeHack(data) {
  return postRequest('/homeHack', data);
}

function updateHomeHack(id, data) {
  return putRequest(`/homeHack/${id}`, data);
}

function deleteHomeHack(data) {
  return deleteRequest('/homeHack', data);
}
// end Master Residence

// Contact start
function getContact(data) {
  return fetchData('/contacts', data);
}

function createContact(data) {
  return postRequest('/contacts', data);
}

function updateContact(id, data) {
  return putRequest(`/contacts/${id}`, data);
}

function deleteContact(id, data) {
  return deleteRequest(`/contacts/${id}`, data);
}
// Home coverage (insurance / warranty) start
function getHomeCoverage(data) {
  return fetchData('/homeCoverage', data);
}

function createHomeCoverage(data) {
  return postRequest('/homeCoverage', data);
}

function updateHomeCoverage(id, data) {
  return putRequest(`/homeCoverage/${id}`, data);
}

function deleteHomeCoverage(id, data) {
  return deleteRequest(`/homeCoverage/${id}`, data);
}
// Address
function getAddress(data) {
  return fetchData('/address', data);
}

function createAddress(data) {
  return postRequest('/address', data);
}

function updateAddress(id, data) {
  return putRequest(`/address/${id}`, data);
}
// End Address

// Home
function getHome(data) {
  return fetchData('/home', data);
}

function createHome(data) {
  return postRequest('/home', data);
}

function updateHome(id, data) {
  return putRequest(`/home/${id}`, data);
}

function fileUploadHome(id, data) {
  return putRequest(`/home/fileUpload/${id}`, data);
}

function fileDeleteHome(id, data) {
  return putRequest(`/home/fileDelete/${id}`, data);
}
// End Home

// Tasks
function getTasks(data) {
  return fetchData('/tasks', data);
}

function getTasksByItemId(id, data) {
  return fetchData(`/tasks/item/${id}`, data);
}

function getTasksId(id, data) {
  return fetchData(`/tasks/item`, data);
}

function getTaskByItemIdWithUserStatus(id, data) {
  return fetchData(`/tasks/taskByItemIdWithUserStatus/${id}`, data);
}

function createTasks(data) {
  return postRequest('/tasks', data);
}

function updateTasks(id, data) {
  return putRequest(`/tasks/${id}`, data);
}
function uploadFileService(id, data) {
  return putRequest(`/tasks/uploadFileService/${id}`, data);
}

function deleteItemsTask(id, data) {
  return deleteRequest(`/tasks/item/${id}`, data);
}

function updateTaskStatus(id, data) {
  return putRequest(`/tasks/updateStatus/${id}`, data);
}

function deleteTaskStatus(id, data) {
  return deleteRequest(`/tasks/deleteStatus/${id}`, data);
}

function getAllTask(data) {
  return fetchData(`/tasks`, data);
}

function getRecentTasks() {
  return fetchData(`/tasks/tasksForDashboard`, {});
}
// End Tasks

// Contact start
function getWarranty(data) {
  return fetchData('/warranty', data);
}

function createWarranty(data) {
  return postRequest('/warranty', data);
}

function updateWarranty(id, data) {
  return putRequest(`/warranty/${id}`, data);
}

function deleteWarranty(id, data) {
  return deleteRequest(`/warranty/${id}`, data);
}

function fileUploadWarranty(id, data) {
  return putRequest(`/warranty/fileUpload/${id}`, data);
}

function getServiceAll() {
  return fetchData(`/warranty/getService`);
}

function getUsersForSendMailTask(data) {
  return postRequest('/service/getUsersForSendMailTask', data);
}

// Company
function getCompany(data) {
  return fetchData('/company', data);
}

function createCompany(data) {
  return postRequest('/company', data);
}

function updateCompany(id, data) {
  return putRequest(`/company/${id}`, data);
}

function deleteCompany(data) {
  return deleteRequest('/company', data);
}
// Company

// Pro users
function getProUsers(id, data) {
  return fetchData(`/users/pro/${id}`, data);
}

function createProUsers(data) {
  return postRequest('/users/pro', data);
}

function updateProUsers(id, data) {
  return putRequest(`/users/pro/${id}`, data);
}

function deleteProUsers(id, data) {
  return putRequest(`/users/pro/delete/${id}`, data);
}
// Pro users

// Customers
function getCustomers(companyId) {
  return fetchData('/customer', { params: { companyId } });
}

function createCustomer(data) {
  return postRequest('/customer', data);
}

function updateCustomer(id, data) {
  return putRequest(`/customer/${id}`, data);
}

function deleteCustomer(data) {
  return deleteRequest('/customer', data);
}

function bulkCreateCustomers(data) {
  return postRequest('/customer/bulk', data);
}
// Customers

// Service Pro: items / warranties / service records on a customer's home
// (cards 17/18/19/20). Authorization is enforced server-side against the caller's
// company + customer list.
function getProHomeItems(params) {
  return fetchData('/service-pro/home-item', { params });
}

// Suggested Outreach (card 33): ranked list of the company's own customers whose
// pro-logged items are due for attention (warranty/service signals).
function getSuggestedOutreach(companyId) {
  return fetchData('/service-pro/outreach', { params: { companyId } });
}

// Customer health & churn (card 38): Healthy/Watch/At-risk/Churning classification
// of the company's own customers + a summary health score.
function getCustomerHealth(companyId) {
  return fetchData('/service-pro/customer-health', { params: { companyId } });
}

// Outreach campaigns (card 44) — the action layer on cards 33/38.
//
// PREVIEW BEFORE SEND is a product rule, not a convenience: previewCampaign runs
// the identical selection the send will run and returns every exclusion with its
// reason. Nothing in the UI should offer a send that has not been previewed.
function previewCampaign(payload) {
  return postRequest('/service-pro/campaigns/preview', payload);
}

function sendCampaign(payload) {
  return postRequest('/service-pro/campaigns/send', payload);
}

function getCampaigns(companyId) {
  return fetchData('/service-pro/campaigns', { params: { companyId } });
}

function getCampaignRecipients(campaignId, companyId) {
  return fetchData(`/service-pro/campaigns/${campaignId}/recipients`, { params: { companyId } });
}

function getSuppressions(companyId) {
  return fetchData('/service-pro/suppressions', { params: { companyId } });
}

// Customer reviews / satisfaction (card 41): log a rating after service; read the
// aggregated summary (avg, star distribution, NPS mix) + recent reviews.
function addCustomerReview(data) {
  return postRequest('/service-pro/review', data);
}

function getCustomerReviews(companyId) {
  return fetchData('/service-pro/review', { params: { companyId } });
}

function createProHomeItem(data) {
  return postRequest('/service-pro/home-item', data);
}

function updateProHomeItem(id, data) {
  return putRequest(`/service-pro/home-item/${id}`, data);
}

function getProItemWarranties(params) {
  return fetchData('/service-pro/item-warranty', { params });
}

function addProItemWarranty(data) {
  return postRequest('/service-pro/item-warranty', data);
}

function updateProItemWarranty(id, data) {
  return putRequest(`/service-pro/item-warranty/${id}`, data);
}

function deleteProItemWarranty(id, companyId) {
  return deleteRequest(`/service-pro/item-warranty/${id}`, { companyId });
}

function getProServiceRecords(params) {
  return fetchData('/service-pro/service-record', { params });
}

function addProServiceRecord(data) {
  return postRequest('/service-pro/service-record', data);
}

function updateProServiceRecord(id, data) {
  return putRequest(`/service-pro/service-record/${id}`, data);
}

function deleteProServiceRecord(id, companyId) {
  return deleteRequest(`/service-pro/service-record/${id}`, { companyId });
}

// Shared catalog used by the pro add-item form (item types) and brand dropdown.
function getItemCatalog() {
  return fetchData('/items');
}

function getBrandList() {
  return fetchData('/brands');
}
// End Service Pro items

// Search Address
function searchAddressFromResiview(data) {
  return postRequest('/users/searchAddress', data);
}

// End Blog or News Post
function getPost(data) {
  return fetchData(`/post`, data);
}

function createPost(data) {
  return postRequest('/post', data);
}

function updatePost(id, data) {
  return putRequest(`/post/${id}`, data);
}

function deletePost(data) {
  return deleteRequest(`/post`, data);
}

function getPostUplically(data) {
  return fetchData(`/post/public`, data);
}

function createPostView(data) {
  return postRequest('/post/views', data);
}

// Onboarding 2.0 (card 188) — collapsed walkthrough + quick-add + next best step
function getResidenceTypes() {
  return fetchData('/onboarding/residence-types');
}

function saveResidenceType(residenceType) {
  return postRequest('/onboarding/residence-type', { residenceType });
}

function getQuickAddCatalog(residenceType) {
  return fetchData('/onboarding/quick-add', { params: { residenceType } });
}

function submitQuickAdd(masterDataIds) {
  return postRequest('/onboarding/quick-add', { masterDataIds });
}

function getNextBestStep() {
  return fetchData('/onboarding/next-best-step');
}
// End Onboarding 2.0

// Task calendar feed (card 203). The returned URL carries a signed token and is
// the credential for a private feed — treat it like a password, never log it.
// Rotating invalidates every URL previously handed out for the account.
function getCalendarSubscription() {
  return fetchData('/calendar/subscription');
}

function rotateCalendarSubscription() {
  return postRequest('/calendar/subscription/rotate');
}

// Home budget & spend tracking (card 193). Amounts travel as integer CENTS in
// both directions — see utils/formatMoney.js.
function getBudget(year) {
  return fetchData('/budget', { params: year ? { year } : {} });
}

function getBudgetSummary() {
  return fetchData('/budget/summary');
}

// Dashboard 2.0 Phase 2 (card 201) — zones 3 and 4. Split from /dashboard/home
// on purpose: these aggregations scan every service record and expense on the
// account, and the hero must not wait on them.
function getDashboardInsights() {
  return fetchData('/dashboard/insights');
}

// Dashboard 2.0 Phase 3 (card 202).
function saveDashboardLayout(data) {
  return putRequest('/dashboard/layout', data);
}

function resetDashboardLayout() {
  return deleteRequest('/dashboard/layout');
}

// Fire-and-forget monetization/engagement tracking. Never awaited by a click
// handler — a tracking call must not delay the link the homeowner just clicked.
function trackEngagement(data) {
  return postRequest('/engagement/event', data);
}

function getReferral() {
  return fetchData('/engagement/referral');
}

// Rewards / points (card 162). Points are only ever awarded server-side — there
// is deliberately no "give me points" endpoint here.
function getRewards() {
  return fetchData('/points');
}

function recordShare(network) {
  return postRequest('/points/share', { network });
}

// Predictive maintenance (card 190). The dashboard reads this off the insights
// payload; this endpoint is for the Budget page's plan-ahead card.
function getPredictive() {
  return fetchData('/predictive');
}

// Home Health Report + safety checks (card 197).
function getHomeHealthReport() {
  return fetchData('/homeHealth/report');
}

function getHomeSafety() {
  return fetchData('/homeHealth/safety');
}

function confirmHomeSafety(key, data) {
  return putRequest(`/homeHealth/safety/${key}`, data);
}

function getHomeHealthShares() {
  return fetchData('/homeHealth/shares');
}

function createHomeHealthShare(data) {
  return postRequest('/homeHealth/shares', data);
}

function revokeHomeHealthShare(id) {
  return deleteRequest(`/homeHealth/shares/${id}`);
}

// Inspection findings on the homeowner's own address (card 198).
function getMyInspections() {
  return fetchData('/inspection/mine');
}

// --- inspector side (card 198) ---------------------------------------------
// Every one of these is authorized server-side against company ownership, the
// same boundary the other pro write paths use — `companyId` in a request is a
// selector, never a grant.
function getInspections(companyId) {
  return fetchData('/inspection', { params: { companyId } });
}

function getInspection(id) {
  return fetchData(`/inspection/${id}`);
}

function createInspection(data) {
  return postRequest('/inspection', data);
}

function addInspectionFinding(id, data) {
  return postRequest(`/inspection/${id}/deficiency`, data);
}

function removeInspectionFinding(id, deficiencyId) {
  return deleteRequest(`/inspection/${id}/deficiency/${deficiencyId}`);
}

function completeInspection(id, buyerEmail) {
  return postRequest(`/inspection/${id}/complete`, { buyerEmail });
}

// Home Care serviceability (card 218). Public — no session needed, because the
// /care page asks before anyone has an account.
function getCareAvailability(zip) {
  return fetchData(`/care/availability?zip=${encodeURIComponent(zip)}`);
}

// Multi-home (card 194). `getHomes` returns { homes, activeHomeId, multiHomeEnabled }.
function getHomes() {
  return fetchData('/homes');
}

// Moves the whole app to another property (card 194e). Every scoped read
// resolves through the active-home flag this sets, so this one write changes
// what every other endpoint returns.
function setActiveHome(homeId) {
  return putRequest('/homes/active', { homeId });
}

// The undo for "Add a property" (194e follow-up). ARCHIVE, never delete: the
// address, items, warranties and spend all stay, and restoring brings the
// property back untouched.
function archiveHome(homeId) {
  return deleteRequest(`/homes/${encodeURIComponent(homeId)}`);
}

function restoreHome(homeId) {
  return postRequest(`/homes/${encodeURIComponent(homeId)}/restore`, {});
}

function renameHome(homeId, label) {
  return putRequest(`/homes/${encodeURIComponent(homeId)}`, { label });
}

function getArchivedHomes() {
  return fetchData('/homes/archived');
}

function createExpense(data) {
  return postRequest('/budget/expense', data);
}

function updateExpense(id, data) {
  return putRequest(`/budget/expense/${id}`, data);
}

function deleteExpense(id) {
  return deleteRequest(`/budget/expense/${id}`);
}

function setAnnualBudget(amount) {
  return putRequest('/budget/annual', { amount });
}

// Notifications (card 161) + dashboard alert bar (card 158). One feed serves the
// bell drawer and the bar: `items` is the history, `barItems` is the subset the
// dashboard promotes. Feed ids are opaque — admin broadcasts come back prefixed
// with "broadcast:" and the backend unpacks that on read/dismiss.
function getNotifications(limit) {
  return fetchData('/notification', { params: { limit } });
}

function markNotificationRead(id) {
  return postRequest(`/notification/${encodeURIComponent(id)}/read`);
}

function markAllNotificationsRead() {
  return postRequest('/notification/read-all');
}

function dismissNotification(id) {
  return postRequest(`/notification/${encodeURIComponent(id)}/dismiss`);
}

// Lead Finder (card 49). No prospect-discovery call exists by design — a
// company sees names only for homeowners who raised a hand.
function getLeads(companyId, status) {
  return fetchData('/service-pro/lead', { params: { companyId, status } });
}

function updateLead(id, data) {
  return putRequest(`/service-pro/lead/${encodeURIComponent(id)}`, data);
}

function getTerritoryDemand(companyId) {
  return fetchData('/service-pro/lead/demand', { params: { companyId } });
}

// Referral performance + neighbourhood reach (card 51).
function getReferralPerformance(companyId) {
  return fetchData('/service-pro/referral', { params: { companyId } });
}

function getCompanyReferralCode(companyId, zipCode) {
  return postRequest('/referral/company', { companyId, zipCode });
}

function claimReferralCode(data) {
  return postRequest('/referral/claim', data);
}

// Ad Manager (card 56). Targeting is validated server-side against real
// territory ownership, not merely constrained here.
function getAdCreatives(companyId) {
  return fetchData('/service-pro/ad', { params: { companyId } });
}

function saveAdCreative(data) {
  return data.creativeId
    ? putRequest(`/service-pro/ad/${encodeURIComponent(data.creativeId)}`, data)
    : postRequest('/service-pro/ad', data);
}

function setAdStatus(id, data) {
  return postRequest(`/service-pro/ad/${encodeURIComponent(id)}/status`, data);
}

// One trade, or an ordered list of trades that all service the thing the ad sits
// next to (card 155). Joined rather than passed as an array because axios
// serializes an array as `serviceType[]=`, which Express reads under a different
// key entirely — the filter would silently vanish and the slot would quietly go
// back to rotating.
function tradeParam(serviceType) {
  if (!serviceType) return undefined;
  const list = (Array.isArray(serviceType) ? serviceType : [serviceType]).filter(Boolean);
  return list.length > 0 ? list.join(',') : undefined;
}

// The signed-in homeowner's own slot (Homeowner card 156). The zip is resolved
// server-side from their scoped address — it is deliberately not a parameter.
function getAdForMyHome(serviceType) {
  return fetchData('/ad/for-me', { params: { serviceType: tradeParam(serviceType) } });
}

// Unauthenticated: ad slots render on pages a signed-out visitor can reach.
function serveAd(zipCode, serviceType) {
  return fetchData('/ad', { params: { zipCode, serviceType: tradeParam(serviceType) } });
}

function recordAdClick(id) {
  return postRequest(`/ad/${encodeURIComponent(id)}/click`);
}

// Territory entitlements (card 42). Distinct from company.zipCodes, which is
// the self-declared service area and grants nothing.
function getTerritories(companyId) {
  return fetchData('/service-pro/territory', { params: { companyId } });
}

function checkTerritoryAvailability(companyId, zipCode, serviceType) {
  return fetchData('/service-pro/territory/availability', {
    params: { companyId, zipCode, serviceType }
  });
}

function claimTerritory(data) {
  return postRequest('/service-pro/territory', data);
}

function releaseTerritory(id, companyId) {
  return postRequest(`/service-pro/territory/${encodeURIComponent(id)}/release`, { companyId });
}

// The limited trial (card 70, epic 57). Metered server-side; these just carry
// the counters back. A refusal comes back as a SUCCESSFUL response with
// `allowed: false` — running out is the expected end of a trial, not an error,
// and rendering it as one would make the product look broken at the exact
// moment it is meant to be making a case for itself.
function getTrial(companyId) {
  return fetchData('/service-pro/trial', { params: { companyId } });
}

function startTrial(data) {
  return postRequest('/service-pro/trial/start', data);
}

function trialAreaInsight(data) {
  return postRequest('/service-pro/trial/area-insight', data);
}

function trialReserveTerritory(data) {
  return postRequest('/service-pro/trial/territory', data);
}

// Service plans & memberships (card 50). Payment collection is card 48 — these
// record who is on a plan and when it ends, not how the money moved.
function getPlanBook(companyId) {
  return fetchData('/service-pro/plan', { params: { companyId } });
}

function saveServicePlan(data) {
  return data.planId
    ? putRequest(`/service-pro/plan/${encodeURIComponent(data.planId)}`, data)
    : postRequest('/service-pro/plan', data);
}

function retireServicePlan(id, companyId) {
  return postRequest(`/service-pro/plan/${encodeURIComponent(id)}/retire`, { companyId });
}

function enrollPlanCustomer(data) {
  return postRequest('/service-pro/plan-membership', data);
}

function updatePlanMembership(id, data) {
  return putRequest(`/service-pro/plan-membership/${encodeURIComponent(id)}`, data);
}

function getMyPlanMemberships() {
  return fetchData('/plan');
}

// Messaging (card 40). Opening a thread is a POST because it clears the unread
// counter for that side.
function getMyMessageThreads() {
  return fetchData('/message');
}

function openMessageThread(companyId) {
  return postRequest('/message/thread', { companyId });
}

function sendMessage(data) {
  return postRequest('/message', data);
}

function getProMessageThreads(companyId) {
  return fetchData('/service-pro/message', { params: { companyId } });
}

function openProMessageThread(companyId, homeownerUID) {
  return postRequest('/service-pro/message/thread', { companyId, homeownerUID });
}

function sendProMessage(data) {
  return postRequest('/service-pro/message', data);
}

// Scheduling & dispatch (card 52). The homeowner call is read-only — a homeowner
// does not move a company's calendar.
function getDispatchBoard(companyId, params = {}) {
  return fetchData('/service-pro/job', { params: { companyId, ...params } });
}

function scheduleJob(data) {
  return postRequest('/service-pro/job', data);
}

function updateJob(id, data) {
  return putRequest(`/service-pro/job/${encodeURIComponent(id)}`, data);
}

function getMyUpcomingJobs() {
  return fetchData('/job');
}

// Estimates & quotes (card 47). The pro composes/sends/withdraws; accept and
// decline are homeowner-only and live on the /quote routes.
function getProQuotes(companyId, serviceRequestId) {
  return fetchData('/service-pro/quote', { params: { companyId, serviceRequestId } });
}

function saveProQuote(data) {
  return data.quoteId
    ? putRequest(`/service-pro/quote/${encodeURIComponent(data.quoteId)}`, data)
    : postRequest('/service-pro/quote', data);
}

function setProQuoteStatus(id, data) {
  return postRequest(`/service-pro/quote/${encodeURIComponent(id)}/status`, data);
}

function getMyQuotes(serviceRequestId) {
  return fetchData('/quote', { params: { serviceRequestId } });
}

function markQuoteViewed(id) {
  return postRequest(`/quote/${encodeURIComponent(id)}/viewed`);
}

function respondToQuote(id, data) {
  return postRequest(`/quote/${encodeURIComponent(id)}/respond`, data);
}

// Invoicing, payment and receipts (card 48). The pro raises and settles; the
// homeowner views and pays.
function getProInvoices(companyId, params = {}) {
  return fetchData('/service-pro/invoice', { params: { companyId, ...params } });
}

function getProInvoice(id, companyId) {
  return fetchData(`/service-pro/invoice/${encodeURIComponent(id)}`, { params: { companyId } });
}

function saveProInvoice(data) {
  return data.invoiceId
    ? putRequest(`/service-pro/invoice/${encodeURIComponent(data.invoiceId)}`, data)
    : postRequest('/service-pro/invoice', data);
}

function sendProInvoice(id, data) {
  return postRequest(`/service-pro/invoice/${encodeURIComponent(id)}/send`, data);
}

function voidProInvoice(id, data) {
  return postRequest(`/service-pro/invoice/${encodeURIComponent(id)}/void`, data);
}

// Recording the check that arrived. Always available — offline payment is a
// real path for home-service companies, not a fallback for missing keys.
function recordInvoicePayment(id, data) {
  return postRequest(`/service-pro/invoice/${encodeURIComponent(id)}/payment`, data);
}

function refundInvoicePayment(id, data) {
  return postRequest(`/service-pro/invoice/${encodeURIComponent(id)}/refund`, data);
}

function getMyInvoices() {
  return fetchData('/invoice');
}

// `token` is the pay-link secret for a customer with no ResiView account; it is
// omitted entirely for a signed-in homeowner.
function getInvoice(id, token) {
  return fetchData(`/invoice/${encodeURIComponent(id)}`, { params: token ? { token } : {} });
}

function startInvoiceCheckout(id, data) {
  return postRequest(`/invoice/${encodeURIComponent(id)}/checkout`, data);
}

// Asks the SERVER to ask the processor what happened. Landing on the success
// URL proves only that a browser landed on a URL.
function confirmInvoicePayment(id, data) {
  return postRequest(`/invoice/${encodeURIComponent(id)}/confirm`, data);
}

// Whether to draw a Pay button at all. Says nothing about which processor is
// behind it — that is deliberately not the frontend's business.
function getPaymentsStatus() {
  return fetchData('/payment/status');
}

// CRM integrations (card 39). Connecting and syncing are owner-only server-side;
// reading status is not.
function getCrmIntegrations(companyId) {
  return fetchData('/crm', { params: { companyId } });
}

function startCrmConnect(data) {
  return postRequest('/crm/connect', data);
}

// Posted by the callback page with the code the CRM handed it, under the user's
// own session — the exchange never happens on an open endpoint.
function completeCrmConnect(data) {
  return postRequest('/crm/callback', data);
}

function disconnectCrm(data) {
  return postRequest('/crm/disconnect', data);
}

function setCrmPreferences(data) {
  return putRequest('/crm/preferences', data);
}

// Bounded per call; `hasMore` in the response means run it again.
function syncCrmCustomers(data) {
  return postRequest('/crm/sync', data);
}

function exportCrmCustomers(data) {
  return postRequest('/crm/export', data);
}

// Homeowner reviews + public company profile (card 45). getCompanyProfile is the
// only call here that works signed OUT — the profile is a public landing page.
function getCompanyProfile(companyId) {
  return fetchData(`/review/company/${encodeURIComponent(companyId)}`);
}

function submitReview(data) {
  return postRequest('/review', data);
}

function getMyReviews(homeItemId) {
  return fetchData('/review/mine', { params: { homeItemId } });
}

// My Service Pros (card 46). One payload: the aggregated pro cards plus the
// homeowner's own open requests, so a card knows whether it already has one
// pending without a second round trip.
function getMyServicePros() {
  return fetchData('/servicePros');
}

function requestService(data) {
  return postRequest('/serviceRequest', data);
}

// Pro end of the same loop: the company's incoming request inbox.
function getProServiceRequests(companyId, status) {
  return fetchData('/service-pro/service-request', { params: { companyId, status } });
}

function updateProServiceRequest(id, data) {
  return putRequest(`/service-pro/service-request/${encodeURIComponent(id)}`, data);
}

// Service Pro notification centre (card 53). Same drawer, different audience: the
// feed belongs to the COMPANY, so every call carries companyId and read/dismiss
// apply for the whole team rather than for the person who clicked.
function getProNotifications(companyId, limit) {
  return fetchData('/service-pro/notification', { params: { companyId, limit } });
}

function markProNotificationRead(companyId, id) {
  return postRequest(`/service-pro/notification/${encodeURIComponent(id)}/read`, { companyId });
}

function markAllProNotificationsRead(companyId) {
  return postRequest('/service-pro/notification/read-all', { companyId });
}

function dismissProNotification(companyId, id) {
  return postRequest(`/service-pro/notification/${encodeURIComponent(id)}/dismiss`, { companyId });
}

function getNotificationPreferences() {
  return fetchData('/notification/preferences');
}

function saveNotificationPreferences(prefs) {
  return putRequest('/notification/preferences', { prefs });
}

// Reached from an email footer, so it carries a signed token instead of a session.
function unsubscribeFromEmails(token) {
  return postRequest(`/unsubscribe/${token}`);
}

// Admin broadcast CRUD behind the alert bar (card 158). Admin-only server-side.
function getBroadcasts() {
  return fetchData('/broadcast');
}

function createBroadcast(data) {
  return postRequest('/broadcast', data);
}

function updateBroadcast(id, data) {
  return putRequest(`/broadcast/${id}`, data);
}

function deleteBroadcast(id) {
  return deleteRequest(`/broadcast/${id}`);
}

function getZipCode(data) {
  return postRequest(`/zipcode`, data);
}

function getStates() {
  return fetchData('/zipcode/states');
}

// End Blog or News Post

const webServices = {
  getMasterData,
  createMasterData,
  updateMasterData,
  deleteMasterData,
  getUsers,
  CreateUser,
  getAllUsers,
  sendMail,
  updateUser,
  confirmUser,
  getMoveItems,
  getToNewUser,
  deleteUser,
  getService,
  createService,
  updateService,
  deleteService,
  softDeleteService,
  fileUploadService,
  fileDeleteService,
  getServiceRecordItems,
  getServiceRecords,
  createServiceRecord,
  updateServiceRecord,
  softDeleteServiceRecord,
  fileUploadServiceRecord,
  fileDeleteServiceRecord,
  getHomeHack,
  getHomeHackAll,
  createHomeHack,
  updateHomeHack,
  deleteHomeHack,
  getRecentEdited,
  getContact,
  createContact,
  updateContact,
  deleteContact,
  getHomeCoverage,
  createHomeCoverage,
  updateHomeCoverage,
  deleteHomeCoverage,
  getAddress,
  createAddress,
  updateAddress,
  getHome,
  createHome,
  updateHome,
  fileUploadHome,
  fileDeleteHome,
  getTasks,
  createTasks,
  updateTasks,
  getTasksByItemId,
  getTasksId,
  deleteItemsTask,
  updateTaskStatus,
  uploadFileService,
  getTaskByItemIdWithUserStatus,
  deleteTaskStatus,
  getAllTask,
  getRecentTasks,
  getWarranty,
  createWarranty,
  updateWarranty,
  deleteWarranty,
  fileUploadWarranty,
  getServiceAll,
  getUsersForSendMailTask,
  getCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  getProUsers,
  createProUsers,
  updateProUsers,
  deleteProUsers,
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  bulkCreateCustomers,
  getProHomeItems,
  getSuggestedOutreach,
  getCustomerHealth,
  previewCampaign,
  sendCampaign,
  getCampaigns,
  getCampaignRecipients,
  getSuppressions,
  addCustomerReview,
  getCustomerReviews,
  createProHomeItem,
  updateProHomeItem,
  getProItemWarranties,
  addProItemWarranty,
  updateProItemWarranty,
  deleteProItemWarranty,
  getProServiceRecords,
  addProServiceRecord,
  updateProServiceRecord,
  deleteProServiceRecord,
  getItemCatalog,
  getBrandList,
  searchAddressFromResiview,
  getPost,
  createPost,
  updatePost,
  deletePost,
  getPostUplically,
  createPostView,
  sendSignUpMail,
  deleteHomeownerAccount,
  inviteResident,
  getResidents,
  deleteResident,
  getMoveWorkflowItems,
  startMove,
  completeMove,
  cancelMove,
  importResidenceItems,
  getZipCode,
  getStates,
  getResidenceTypes,
  saveResidenceType,
  getQuickAddCatalog,
  submitQuickAdd,
  getNextBestStep,
  getCalendarSubscription,
  rotateCalendarSubscription,
  getBudget,
  getBudgetSummary,
  getDashboardInsights,
  saveDashboardLayout,
  resetDashboardLayout,
  trackEngagement,
  getReferral,
  getRewards,
  recordShare,
  getPredictive,
  getHomeHealthReport,
  getHomeSafety,
  confirmHomeSafety,
  getHomeHealthShares,
  createHomeHealthShare,
  revokeHomeHealthShare,
  getMyInspections,
  getInspections,
  getInspection,
  createInspection,
  addInspectionFinding,
  removeInspectionFinding,
  completeInspection,
  getHomes,
  setActiveHome,
  archiveHome,
  restoreHome,
  renameHome,
  getArchivedHomes,
  getCareAvailability,
  createExpense,
  updateExpense,
  deleteExpense,
  setAnnualBudget,
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  dismissNotification,
  getLeads,
  updateLead,
  getTerritoryDemand,
  getReferralPerformance,
  getCompanyReferralCode,
  claimReferralCode,
  getAdCreatives,
  saveAdCreative,
  setAdStatus,
  getAdForMyHome,
  serveAd,
  recordAdClick,
  getTerritories,
  checkTerritoryAvailability,
  claimTerritory,
  releaseTerritory,
  getTrial,
  startTrial,
  trialAreaInsight,
  trialReserveTerritory,
  getPlanBook,
  saveServicePlan,
  retireServicePlan,
  enrollPlanCustomer,
  updatePlanMembership,
  getMyPlanMemberships,
  getMyMessageThreads,
  openMessageThread,
  sendMessage,
  getProMessageThreads,
  openProMessageThread,
  sendProMessage,
  getDispatchBoard,
  scheduleJob,
  updateJob,
  getMyUpcomingJobs,
  getProQuotes,
  saveProQuote,
  setProQuoteStatus,
  getMyQuotes,
  markQuoteViewed,
  respondToQuote,
  getProInvoices,
  getProInvoice,
  saveProInvoice,
  sendProInvoice,
  voidProInvoice,
  recordInvoicePayment,
  refundInvoicePayment,
  getMyInvoices,
  getInvoice,
  startInvoiceCheckout,
  confirmInvoicePayment,
  getPaymentsStatus,
  getCrmIntegrations,
  startCrmConnect,
  completeCrmConnect,
  disconnectCrm,
  setCrmPreferences,
  syncCrmCustomers,
  exportCrmCustomers,
  getCompanyProfile,
  submitReview,
  getMyReviews,
  getMyServicePros,
  requestService,
  getProServiceRequests,
  updateProServiceRequest,
  getProNotifications,
  markProNotificationRead,
  markAllProNotificationsRead,
  dismissProNotification,
  getNotificationPreferences,
  saveNotificationPreferences,
  unsubscribeFromEmails,
  getBroadcasts,
  createBroadcast,
  updateBroadcast,
  deleteBroadcast
};

export default webServices;
